import React, { useState } from "react";
import "./aboutus.css";
import wedesign from "../../interior_assets/aboutus/wedesign1.jpeg";
import wemanage from "../../interior_assets/aboutus/wemanage1.jpeg";
import weexecute from "../../interior_assets/aboutus/weexecute1.jpeg";
import Contactpopup from "../contact_popup/contactpopup";

export default function About() {
   const [showpopup, setShowpopup] = useState(false);
      
        const openPopup = () => {
          setShowpopup(true);
        }
      
        const closePopup = () => {
          setShowpopup(false);
        }
  return (
    <>
    <div className="container aboutus-containermain">
      <div className=" aboutus">
        {/* Complete Turnkey  aboutus - No Image, Only Button */}
        <div className=" aboutus-card aboutus-card-color">
        
          <h4 className="aboutus-title-main" 
          >Complete Turnkey  Services</h4>
          <p className="aboutus-description-main" >
            We specialize in complete turnkey interior  services, ensuring a seamless experience from concept to completion. With 32 successfully completed projects, we have built a reputation for quality, efficiency, and innovation.
          </p>
          <button className="aboutus-button" onClick={openPopup}>Learn More</button>
        </div>

        {/* We Design */}
        <div className=" aboutus-card">
          <img src={wedesign} alt="We Design" className="aboutus-image" />
          <h4 className="aboutus-title">We Design</h4>
          <p className="aboutus-description">
          We specialize in complete interior solutions, offering stunning modular designs and turnkey interiors for homes, offices, and commercial spaces. From concept to execution, we create functional, stylish, High-quality interiors that bring your vision to life!</p>        </div>

        {/* We Execute */}
        <div className=" aboutus-card">
          <img src={weexecute} alt="We Execute" className="aboutus-image" />
          <h4 className="aboutus-title">We Execute</h4>
          <p className="aboutus-description">
          We Execute with precision, quality, and excellence, ensuring seamless execution and on-time delivery. With innovation and craftsmanship, we create spaces that inspire and elevate your lifestyle.</p>        </div>

        {/* We Manage */}
        <div className=" aboutus-card">
          <img src={wemanage} alt="We Manage" className="aboutus-image" />
          <h4 className="aboutus-title">We Manage</h4>
          <p className="aboutus-description">
          We expertly handle every aspect of interior design, ensuring seamless execution of modular interiors, space planning, and turnkey solutions. With precision, style, and efficiency, we bring your vision to life—on time and within budget.            </p>
        </div>
      </div>
    </div>

{ showpopup && <Contactpopup onClose={closePopup} /> }
</>
  );
}
